import { FC } from "react";
import { Box } from "@mui/material";
import AppModal from "../../../../components/ui/AppModal";
import { TutorialModel } from "../../../../models/TutorialModel";

type Props = {
  video: TutorialModel | null;
  onClose: () => void;
};

/** Modal com o player do YouTube. */
const TutorialPlayerModal: FC<Props> = ({ video, onClose }) => (
  <AppModal open={Boolean(video)} onClose={onClose} title={video?.title ?? ""} subtitle={video?.subtitle} maxWidth={760}>
    {video && (
      <Box sx={{ position: "relative", width: "100%", paddingTop: "56.25%", borderRadius: "10px", overflow: "hidden", backgroundColor: "#000" }}>
        <Box
          component="iframe"
          src={`https://youtube.com/embed/${video.url}?autoplay=0`}
          title={video.title}
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; web-share"
          allowFullScreen
          sx={{ position: "absolute", inset: 0, width: "100%", height: "100%", border: "none" }}
        />
      </Box>
    )}
  </AppModal>
);

export default TutorialPlayerModal;
